import {
    CORE_LOAD_TERM_REQUEST,
    CORE_LOAD_TERM_SUCCESS,

    CORE_LOAD_CONTACT_REQUEST,
    CORE_LOAD_CONTACT_SUCCESS,

    CORE_LOAD_FAQ_REQUEST,
    CORE_LOAD_FAQ_SUCCESS,

    CORE_LOAD_TIMEZOZE_REQUEST,
    CORE_LOAD_TIMEZOZE_SUCCESS,
} from '../../types'

const initialState = []

export default {
    contact: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_CONTACT_REQUEST:
                return {}
            case CORE_LOAD_CONTACT_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    faq: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_FAQ_REQUEST:
                return {}
            case CORE_LOAD_FAQ_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    term: (state = {}, action) => {
        switch (action.type) {
            case CORE_LOAD_TERM_REQUEST:
                return {}
            case CORE_LOAD_TERM_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    timezone: (state = {}, action) => {
        switch (action.type) {
            case CORE_LOAD_TIMEZOZE_REQUEST:
                return {}
            case CORE_LOAD_TIMEZOZE_SUCCESS:
                return action.payload
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/features/informations/reducer.js